import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Icon } from '@pella/sash-framework';
import { useGlobalConfig } from '../../../../hooks/use-global-config';

const CustomerShowroomText = ({ className, showroomData, showInfo = true, infoPosition = 'left' }) => {
	const { showroom } = useGlobalConfig();

	if (!showroomData) return null;

	const renderContentData = (showroomInfo) => {
		const hoursArray = [showroomInfo.hour_mon, showroomInfo.hour_tue, showroomInfo.hour_wed, showroomInfo.hour_thu, showroomInfo.hour_fri, showroomInfo.hour_sat, showroomInfo.hour_sun];

		if (hoursArray.filter((hour) => !hour || ['By Appointment', 'Temporarily Closed', 'Closed'].includes(hour))?.length > 4) {
			return showroom.showroom_type.find((type) => type.type === 'trade');
		} else {
			return showroom.showroom_type.find((type) => type.type === 'retail');
		}
	};

	const contentData = renderContentData(showroomData);

	return (
		<div
			className={`customerShowroomText flex flex-row items-center ${className || ''}`}
			data-testid='customer-showroom-text'
		>
			{contentData?.material_symbol && (
				<Icon
					name={contentData.material_symbol}
					className='mr-2 text-black'
				/>
			)}

			{contentData?.heading && (
				<div
					dangerouslySetInnerHTML={{ __html: contentData.heading }}
					className='text-sm'
				/>
			)}

			{showInfo && contentData?.tooltip && (
				<Dropdown className='group z-10 ml-1 self-start'>
					<Dropdown.Trigger>
						<Icon
							name='info'
							size={16}
							className='text-black'
						/>
					</Dropdown.Trigger>
					<Dropdown.Content className={`w-max max-w-[250px] xl:group-focus-within:!block xl:group-hover:!block ${infoPosition === 'right' ? '!left-auto right-0' : ''}`}>
						<div
							className='text-xs'
							dangerouslySetInnerHTML={{ __html: contentData.tooltip }}
						/>
					</Dropdown.Content>
				</Dropdown>
			)}
		</div>
	);
};

CustomerShowroomText.propTypes = {
	showroomData: PropTypes.object.isRequired,
	className: PropTypes.string,
	showInfo: PropTypes.bool,
	infoPosition: PropTypes.string,
};

export default CustomerShowroomText;
